<template>
  <div>
    <v-alert
      v-if="invalidCredentials"
      border="left"
      color="danger"
      type="warning"
      dense
    >
      {{ errorMessage }}
    </v-alert>
    <validation-observer ref="observer">
      <v-form ref="form" @submit.prevent="handleLogin">
        <validation-provider
          v-slot="{ errors }"
          name="username"
          :rules="rules.username"
        >
          <v-text-field
            v-model="formData.username"
            :error-messages="errors"
            label="Username"
            outlined
            dense
            required
          ></v-text-field>
        </validation-provider>
        <validation-provider
          v-slot="{ errors }"
          name="password"
          :rules="rules.password"
        >
          <v-text-field
            v-model="formData.password"
            :error-messages="errors"
            label="Password"
            type="password"
            outlined
            dense
            required
          ></v-text-field>
        </validation-provider>
        <div class="d-flex justify-space-between pt-6">
          <v-btn :to="{ name: 'Home' }" color="primary" plain>
            <v-icon left>fa-arrow-left</v-icon>
            กลับหน้าหลัก
          </v-btn>
          <v-btn color="primary" :loading="isLoading" type="submit">
            เข้าสู่ระบบ
          </v-btn>
        </div>
      </v-form>
    </validation-observer>
  </div>
</template>

<script>
import _ from "lodash"
import { mapGetters } from "vuex"
import { LOGIN } from "@/store/action.type"
import { formValidateError } from "@/common/helper"

export default {
  name: "FormLogin",
  data() {
    return {
      formData: {
        username: "",
        password: "",
        device_name: navigator.userAgent + " " + new Date().getTime(),
      },
      rules: {
        username: "required",
        password: "required",
      },
      invalidCredentials: false,
      isLoading: false,
      errorMessage: "",
    }
  },
  computed: {
    ...mapGetters(["authError"]),
  },
  methods: {
    async handleLogin() {
      this.isLoading = true
      const validated = await this.$refs.observer.validate()
      this.invalidCredentials = false

      if (validated) {
        await this.$store.dispatch(LOGIN, this.formData)
        if (!_.isEmpty(this.authError)) {
          this.errorMessage =
            this.authError.error.message || "Username หรือ Password ไม่ถูกต้อง"
          formValidateError(this, this.authError)
        } else {
          this.$router.push({ name: "Home" })
        }
      }

      this.isLoading = false
    },
  },
}
</script>